// extracted by mini-css-extract-plugin
module.exports = {"s66oevi":"s66oevi","c1s1ejix":"c1s1ejix"};